<div container classes="container">
  <div
    class="references__accordion position-relative z-0 d-flex flex-column gap-3"
    ngbAccordion
    #accordions="ngbAccordion"
  >
    <div ngbAccordionItem="references-item" [destroyOnHide]="false">
      <h2 ngbAccordionHeader>
        <button ngbAccordionButton id="references-toggle">
          <h3 class="mb-0">References</h3>
        </button>
      </h2>
      <div ngbAccordionCollapse>
        <div ngbAccordionBody>
          <ng-template>
            <div class="references-content">
              <ol>
                <li>
                  Diabetes Leadership Council. Type 1 Diabetes Early Detection. Gettingaheadoftype1.org. Published
                  2025. https://www.gettingaheadoftype1.org/resources/providers
                </li>
                <li>
                  Duca LM, Reboussin BA, Pihoker C, et al. Diabetic ketoacidosis at diagnosis of type 1 diabetes and
                  glycemic control over time: The SEARCH for diabetes in youth study. Pediatric Diabetes.
                  2018;20(2):172-179. doi:https://doi.org/10.1111/pedi.12809
                </li>
                <li>
                  When Type 1 Diabetes Strikes Older Adults. Columbia University Irving Medical Center. Published
                  December 17, 2021.
                  https://www.cuimc.columbia.edu/news/when-type-1-diabetes-strikes-older-adults
                </li>
                <li>
                  Sweet K. Type 1 diabetes vs. type 2 diabetes. Breakthrough T1D. Published January 6, 2023.
                  https://www.breakthrought1d.org/news-and-updates/type-1-diabetes-vs-type-2-diabetes/
                </li>
                <li>
                  The Lancet Regional Health – Europe. Misdiagnosis of type 1 and type 2 diabetes in adults. The
                  Lancet Regional Health - Europe. 2023;29(100661).
                  doi:https://doi.org/10.1016/j.lanepe.2023.100661
                </li>
                <li>
                  Cleveland Clinic. Diabetes-Related Ketoacidosis (DKA). Cleveland Clinic. Published 2024.
                  https://my.clevelandclinic.org/health/diseases/21945-diabetic-ketoacidosis-dka
                </li>
                <li>
                  Beyond Type 1. Screening for Type 1 Diabetes. Beyond Type 1.
                  https://beyondtype1.org/screening-for-type-1-diabetes/
                </li>
                <li>
                  Testa R, Bonfigli AR, Prattichizzo F, La Sala L, De Nigris V, Ceriello A. The “Metabolic Memory”
                  Theory and the Early Treatment of Hyperglycemia in Prevention of Diabetic Complications. Nutrients.
                  2017;9(5):437. doi:https://doi.org/10.3390/nu9050437
                </li>
                <li>
                  Nathan DM. Realising the long-term promise of insulin therapy: the DCCT/EDIC study. Diabetologia.
                  2021;64(5):1049-1058. doi:https://doi.org/10.1007/s00125-021-05397-4
                </li>
                <li>
                  Aiello LP. Diabetic Retinopathy and Other Ocular Findings in the Diabetes Control and Complications
                  Trial/Epidemiology of Diabetes Interventions and Complications Study. Diabetes Care. 2013;37(1):17-23.
                  doi:https://doi.org/10.2337/dc13-2251
                </li>
                <li>
                  Owens DR. Clinical Evidence for the Earlier Initiation of Insulin Therapy in Type 2 Diabetes.
                  Diabetes Technology & Therapeutics. 2013;15(9):776-785.
                  doi:https://doi.org/10.1089/dia.2013.0081
                </li>
                <li>
                  Rodriguez-Munoz A, Picon-Cesar MJ, Tinahones FJ, et al. Type 1 diabetes–related distress: current
                  implications in care. Eur J Intern Med. 2024;125:19-27.
                </li>
                <li>
                  Sims EK, Besser REJ, Dayan C, et al. Screening for Type 1 Diabetes in the General Population: A Status
                  Report and Perspective. Diabetes. 2022;71(4):610-623.
                  doi:https://doi.org/10.2337/dbi20-0054
                </li>
                <li>
                  Scheiner G, Weiner S, Kruger D, Pettus J. Screening for type 1 diabetes: role of the diabetes care and
                  education specialist. ADCES Pract. 2022;10(5):20-25.
                  doi:https://doi.org/10.1177/2633559x221110216
                </li>
                <li>
                  Insel RA, Dunne JL, Atkinson MA, et al. Staging presymptomatic type 1 diabetes: a scientific statement
                  of JDRF, the Endocrine Society, and the American Diabetes Association. Diabetes Care.
                  2015;38(10):1964-1974. https://doi.org/10.2337/dc15-1419
                </li>
                <li>
                  Type 1 Diabetes TrialNet. T1D Facts. www.trialnet.org.
                  https://www.trialnet.org/t1d-facts
                </li>
                <li>
                  Podobnik B, Korošak D, Skelin Klemen M, et al. β cells operate collectively to help maintain glucose
                  homeostasis. Biophys J. 2020;118(10):2588-2595. doi:10.1016/j.bpj.2020.04.005
                </li>
                <li>
                  Laffel LM, Kanapka LG, Beck RW, et al; CGM Intervention in Teens and Young Adults with T1D (CITY)
                  Study Group. Effect of continuous glucose monitoring on glycemic control in adolescents and young
                  adults with type 1 diabetes: a randomized clinical trial. JAMA. 2020;323(23):2388-2396.
                </li>
                <li>
                  Kramer CK, Retnakaran R, Zinman B. Insulin and insulin analogs as antidiabetic therapy: a perspective
                  from clinical trials. Cell Metab. 2021;33(4):740-747.
                </li>
                <li>
                  Herold KC, Delong T, Perdigoto AL, Biru N, Brusko TM, Walker LSK. The immunology of type 1 diabetes.
                  Nature Reviews Immunology. 2024;24(6):1-17.
                  doi:https://doi.org/10.1038/s41577-023-00985-4
                </li>
                <li>
                  Burrack AL, Martinov T, Fife BT. T Cell-Mediated Beta Cell Destruction: Autoimmunity and Alloimmunity
                  in the Context of Type 1 Diabetes. Frontiers in Endocrinology. 2017;8:343.
                  doi:https://doi.org/10.3389/fendo.2017.00343
                </li>
                <li>
                  Latres E, Greenbaum CJ, Oyaski ML, et al. Evidence for C-peptide as a Validated Surrogate to Predict
                  Clinical Benefits in Trials of Disease-Modifying Therapies for Type 1 Diabetes. Diabetes.
                  2024;73(6):823-833. doi:https://doi.org/10.2337/dbi23-0012
                </li>
                <li>
                  Mayo Clinic Staff. Type 1 Diabetes. Mayo Clinic. Published March 27, 2024.
                  https://www.mayoclinic.org/diseases-conditions/type-1-diabetes/symptoms-causes/syc-20353011
                </li>
                <li>
                  Gubitosi-Klug RA, Braffett BH, Hitt S, et al; DCCT/EDIC Research Group. Residual β cell function in
                  long-term type 1 diabetes associates with reduced incidence of hypoglycemia. J Clin Invest.
                  2021;131(3):e143011.
                </li>
                <li>
                  Jeyam A, Colhoun H, McGurnaghan S, et al; SDRNT1BIO Investigators. Clinical impact of residual
                  C-peptide secretion in type 1 diabetes on glycemia and microvascular complications. Diabetes Care.
                  2021;44(2):390-398.
                </li>
                <li>
                  Palmer JP, Fleming GA, Greenbaum CJ, et al. C-peptide is the appropriate outcome measure for type 1
                  diabetes clinical trials to preserve β-cell function: report of an ADA workshop, 21-22 October 2001.
                  Diabetes. 2004;53(1):250-264.
                </li>
                <li>
                  Lachin JM, McGee P, Palmer JP; DCCT/EDIC Research Group. Impact of C-peptide preservation on metabolic
                  and clinical outcomes in the Diabetes Control and Complications Trial. Diabetes. 2014;63(2):739-748.
                </li>
                <li>
                  Steffes MW, Sibley S, Jackson M, et al. β-cell function and the development of diabetes-related
                  complications in the diabetes control and complications trial. Diabetes Care. 2003;26(3):832-836.
                </li>
                <li>
                  Leighton E, Sainsbury CAR, Jones GC. A practical review of C-peptide testing in diabetes. Diabetes
                  Ther. 2017;8(3):475-487.
                </li>
                <li>
                  Lachin JM, Nathan DM; DCCT/EDIC Research Group. Understanding Metabolic Memory: The Prolonged
                  Influence of Glycemia During the Diabetes Control and Complications Trial (DCCT) on Future Risks of
                  Complications During the Study of the Epidemiology of Diabetes Interventions and Complications (EDIC).
                  Diabetes Care. 2021 Sep 21;44(10):2216–24. doi: 10.2337/dc20-3097. Epub ahead of print. PMID:
                  34548284; PMCID: PMC8929187.
                </li>
                <li>
                  Cameron FJ, Scratch SE, Nadebaum C, et al. Neurological Consequences of Diabetic Ketoacidosis at
                  Initial Presentation of Type 1 Diabetes in a Prospective Cohort Study of Children. Diabetes Care.
                  2014;37(6):1554-1562. doi:https://doi.org/10.2337/dc13-1904
                </li>
                <li>
                  Muñoz C, Floreen A, Garey C, et al. Misdiagnosis and Diabetic Ketoacidosis at Diagnosis of Type 1
                  Diabetes: Patient and Caregiver Perspectives. Clinical Diabetes : A Publication of the American
                  Diabetes Association. 2019;37(3):276-281.
                  doi:https://doi.org/10.2337/cd18-0088
                </li>
                <li>
                  Bonadio W. The Evaluation and Management of Pediatric Diabetic Ketoacidosis: A Comprehensive Review.
                  Clinical Pediatrics. 2022;62(6):000992282211399.
                  doi:https://doi.org/10.1177/00099228221139982
                </li>
                <li>
                  Moffett MA, Buckingham JC, Baker CR, Hawthorne G, Leech NJ. Patients’ experience of admission to
                  hospital with diabetic ketoacidosis and its psychological impact: an exploratory qualitative study.
                  Practical Diabetes. 2013;30(5):203-207. doi:https://doi.org/10.1002/pdi.1777
                </li>
                <li>
                  Duca LM, Wang B, Rewers M, Rewers A. Diabetic Ketoacidosis at Diagnosis of Type 1 Diabetes Predicts
                  Poor Long-term Glycemic Control. Diabetes Care. 2017;40(9):1249-1255.
                  doi:https://doi.org/10.2337/dc17-0558
                </li>
              </ol>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>
